import RestError from '../../modules/app/errors';

export class AccountForbiddenError extends RestError {}
export class AccountConflictError extends RestError {}
